// eslint-disable-next-line import/prefer-default-export
export function TimeTracker(minimum = 1000) {
  let start
  let end
  let remainingTime = 0

  function capture() {
    if (!start) {
      start = Date.now()
      return
    }

    if (!end) {
      end = Date.now()
    }

    remainingTime = Math.max(0, minimum - (end - start))
  }

  function wait() {
    if (remainingTime === 0) {
      return Promise.resolve()
    }

    return new Promise(resolve => window.setTimeout(resolve, remainingTime))
  }

  return {
    capture,
    wait
  }
}
